import Component from '../../../shared/component';

export default class InternshipTypeSelector extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);
    this.$options = this.$element.find('.internshipTypeSelector-option');

    this.bindEvents();
  }

  bindEvents() {
    this.handleOptionClick = this.handleOptionClick.bind(this);

    this.$options.on('click.InternshipTypeSelector', this.handleOptionClick);
  }

  unbindEvents() {
    this.$options.off('click.InternshipTypeSelector', this.handleOptionClick);
  }

  handleOptionClick(event) {
    const $option = $(event.currentTarget);
    const $checkBox = $option.find('input[type=checkbox]');

    if ($checkBox.prop('checked')) {
      $checkBox.prop('checked', false);
      $option.removeClass('internshipTypeSelector-option--selected');
    } else {
      $checkBox.prop('checked', true);
      $option.addClass('internshipTypeSelector-option--selected');
    }
  }
}
